import { createRouter, createWebHistory } from 'vue-router'
import Loader from '../views/Loader.vue'
import Office from '../views/Office.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Loader,
      meta: {
        title: 'Portfolio | Braxton Freeman - Software Developer',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://www.ibraxton.dev'
          },
          {
            name: 'title',
            content: 'Portfolio | Braxton Freeman - Software Developer'
          },
          {
            name: 'description',
            content:
              "Discover the portfolio of Braxton Freeman, a passionate software developer specializing in Python, JavaScript, C++, and web development."
          },
          {
            name: 'keywords',
            content: 'portfolio, braxton freeman, software developer, python, javascript, c++, web development, full stack'
          },
          {
            name: 'author',
            content: 'Braxton Freeman'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Portfolio | Braxton Freeman - Software Developer'
          },
          {
            name: 'application-name',
            content: 'Portfolio | Braxton Freeman - Software Developer'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Portfolio | Braxton Freeman - Software Developer'
          },
          {
            name: 'twitter:description',
            content:
              "Discover the portfolio of Braxton Freeman, a passionate software developer specializing in Python, JavaScript, C++, and web development."
          },
          {
            name: 'twitter:image',
            content: 'https://www.ibraxton.dev/img/prof.png'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Braxton Freeman'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:title',
            content: 'Portfolio | Braxton Freeman - Software Developer'
          },
          {
            property: 'og:description',
            content:
              "Discover the portfolio of Braxton Freeman, a passionate software developer specializing in Python, JavaScript, C++, and web development."
          },
          {
            property: 'og:site_name',
            content: 'Portfolio | Braxton Freeman - Software Developer'
          },
          {
            property: 'og:url',
            content: 'https://www.ibraxton.dev'
          },
          {
            property: 'og:image',
            content: 'https://www.ibraxton.dev/img/prof.png'
          },
          {
            property: 'og:image:alt',
            content: 'Logo Portfolio Braxton Freeman'
          },
          {
            property: 'og:locale',
            content: 'en_US'
          },
          {
            property: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    },
    {
      path: '/office',
      name: 'Office',
      component: Office,
      meta: {
        title: 'Desktop | Braxton Freeman - Software Developer',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://www.ibraxton.dev/office'
          },
          {
            name: 'title',
            content: 'Desktop | Braxton Freeman - Software Developer'
          },
          {
            name: 'description',
            content:
              "Explore the desktop of Braxton Freeman, a passionate software developer specializing in Python, JavaScript, C++, and web development."
          },
          {
            name: 'keywords',
            content: 'desktop, braxton freeman, software developer, python, javascript, c++, web development, full stack'
          },
          {
            name: 'author',
            content: 'Braxton Freeman'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Desktop | Braxton Freeman - Software Developer'
          },
          {
            name: 'application-name',
            content: 'Desktop | Braxton Freeman - Software Developer'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Desktop | Braxton Freeman - Software Developer'
          },
          {
            name: 'twitter:description',
            content:
              "Explore the desktop of Braxton Freeman, a passionate software developer specializing in Python, JavaScript, C++, and web development."
          },
          {
            name: 'twitter:image',
            content: 'https://www.ibraxton.dev/img/prof.png'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Braxton Freeman'
          },
          {
            name: 'og:type',
            content: 'website'
          },
          {
            name: 'og:title',
            content: 'Desktop | Braxton Freeman - Software Developer'
          },
          {
            name: 'og:description',
            content:
              "Explore the desktop of Braxton Freeman, a passionate software developer specializing in Python, JavaScript, C++, and web development."
          },
          {
            name: 'og:site_name',
            content: 'Desktop | Braxton Freeman - Software Developer'
          },
          {
            name: 'og:url',
            content: 'https://www.ibraxton.dev/office'
          },
          {
            name: 'og:image',
            content: 'https://www.ibraxton.dev/img/prof.png'
          },
          {
            name: 'og:image:alt',
            content: 'Logo Portfolio Braxton Freeman'
          },
          {
            name: 'og:locale',
            content: 'en_US'
          },
          {
            name: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    }
  ]
})

export default router
